/* eslint-disable camelcase */
/* eslint-disable ordered-imports/ordered-imports */
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import setPageMetadata from "@insite/client-framework/Common/Utilities/setPageMetadata";
import { trackPageChange } from "@insite/client-framework/Common/Utilities/tracking";
import { ParentProductIdContext } from "@insite/client-framework/Components/ParentProductContext";
import { ProductContext, ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import Zone from "@insite/client-framework/Components/Zone";
import { getSelectedProductPath, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCatalogPageStateByPath } from "@insite/client-framework/Store/Data/CatalogPages/CatalogPagesSelectors";
import { getCurrentPage, getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getProductState, getProductStateByPath } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import changeQtyOrdered from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/ChangeQtyOrdered";
import changeUnitOfMeasure from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/ChangeUnitOfMeasure";
import displayProduct from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/DisplayProduct";
// import displayProduct from "@NA/Overrides/Store/Pages/ProductDetails/Handlers/DisplayProduct";
import resetSelections from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/ResetSelections";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import CurrentCategory from "@insite/content-library/Components/CurrentCategory";
import Modals from "@insite/content-library/Components/Modals";
import Page from "@insite/mobius/Page";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import ProductCompareFlyOut from "@NA/Overrides/Components/ProductCompareFlyOut";
import ScrollToTop from "@NA/Components/ScrollToTop";
import Hidden from "@insite/mobius/Hidden";
import { getComputedVariantProduct } from "@NA/Store/Selector/ADIProductsSelector";
import { getCurrentShipToState } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import loadCurrentShipTo from "@insite/client-framework/Store/Data/ShipTos/Handlers/LoadCurrentShipTo";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import LoadInventoryPuddles from "@NA/Handlers/GetInventoryPuddles";
import { pushProductDetailDataToDataLayer } from "@NA/Overrides/Common/Utilities/CustomTracking";
import LoadingOverlay from "@insite/mobius/LoadingOverlay";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";
import bannerCarousel from "@NA/Handlers/ADIGetBannerCarouselHandler";
import loadEddMethods from "@NA/Handlers/ADIGetEddMethodHandler";
import { useIsPRDomain as getIsPRDomain } from "@NA/Utils/Utility";
import { HasCoveoHooks, withCoveoHooks } from "@NA/Components/Coveo/Contexts/CoveoHooksContext";
import isMobile from "ismobilejs";

export function IsLBInonSplOrdANDnotLB(product: any): string {
    let lbi = "0";
    lbi =
        (!(product?.properties?.inventoryMessage?.toLowerCase() === "special order") ||
            ((product?.properties?.classificatioN_CODE === "S" ||
                product?.properties?.classificatioN_CODE === "P" ||
                product?.properties?.classificatioN_CODE === "L") &&
                product?.properties["inventoryMessageType"] === "3")) &&
        product?.properties?.lbi?.toLowerCase() === "yes" &&
        product?.properties?.logicBroker?.toLowerCase() !== "yes"
            ? "1"
            : "0";
    return lbi;
}
const mapStateToProps = (state: CustomApplicationState) => {
    const location = getLocation(state);
    const productPath =
        getSelectedProductPath(state) ||
        (location.pathname.toLowerCase().startsWith("/content/") ? "" : location.pathname);
    const productState = getProductStateByPath(state, productPath);
    const catalogPageState = getCatalogPageStateByPath(state, productPath);
    const variantProductState = getProductState(state, state.pages.productDetails.selectedProductId);
    const computedVariantProduct = getComputedVariantProduct(productState, variantProductState);
    const billToId = state.context.session.billToId;
    const catalogSettings = state.context.settings.settingsCollection.catalogSettingSettings as any;
    let acNoSession;
    if (billToId) {
        acNoSession = state.data.billTos.byId[billToId]?.customerNumber;
    }

    return {
        productState: computedVariantProduct,
        catalogPageState,
        parentProductState: productState,
        productInfo:
            computedVariantProduct.value && state.pages.productDetails.productInfosById
                ? state.pages.productDetails.productInfosById[computedVariantProduct.value.id]
                : undefined,
        productPath,
        lastProductPath: state.pages.productDetails.lastProductPath,
        lastStyledOption: state.pages.productDetails.lastStyledOption,
        websiteName: state.context.website.name,
        page: getCurrentPage(state),
        location,
        websiteSettings: getSettingsCollection(state).websiteSettings,
        selectedProductId: state.pages.productDetails.selectedProductId,
        isProductLoading: state.pages.productDetails.isProductLoading,
        currentShipToState: getCurrentShipToState(state),
        session: state.context.session,
        currentShipToStateIsLoading: getCurrentShipToState(state).isLoading,
        inventoryPuddles: state.ADIGlobalData.PdpInventoryPuddlesStore,
        inventoryEDD: state.ADIGlobalData.ADIInventoryEDDStore, // This property is a P21 Change
        isAuthenticated: state.context.session.isAuthenticated,
        adiInventory: state.ADIGlobalData.wareHouseDataStore,
        coveoCommerce: state.ADIGlobalData.coveoCommerce,
        bannerCarouselList: state.ADIGlobalData.bannerCarouselStore.bannerCarousel?.bannerCarouselList,
        acNoSession,
        userRoles: state.context.session.userRoles,
        loyaltyUserStateStore: state.ADIGlobalData.loyaltyRewardUserStore,
        userNameSession: state.context.session.userName?.toLocaleLowerCase(),
        catalogSettings,
    };
};

const mapDispatchToProps = {
    displayProduct,
    changeQtyOrdered,
    changeUnitOfMeasure,
    resetSelections,
    loadCurrentShipTo,
    LoadInventoryPuddles,
    bannerCarousel,
    loadEddMethods,
};

export interface ProductDetailsPageStyles {
    loadingOverlay?: InjectableCss;
}

export const productDetailsPageStyles: ProductDetailsPageStyles = {
    loadingOverlay: {
        css: css`
            min-height: ${isMobile() ? "500px" : "700px"};
            & > div:first-child[data-loading="true"] {
                position: fixed;
            }
        `,
    },
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & PageProps & HasCoveoHooks;
interface State {
    metadataSetForId?: string;
    isdataLayerLogged?: boolean;
    isBannerLoaded: boolean;
}

// In the below class, EDD related changes are from p21 Change ----- P21 Change
class ProductDetailsPage extends React.Component<Props, State> {
    private makePuddlesCall: React.RefObject<boolean>;
    constructor(props: Props) {
        super(props);
        this.makePuddlesCall = React.createRef();
        (this.makePuddlesCall as React.MutableRefObject<boolean>).current = true;

        this.state = {
            isBannerLoaded: false,
        };
    }

    loadBanner() {
        const {
            productState,
            bannerCarousel,
            acNoSession,
            userRoles,
            loyaltyUserStateStore,
            userNameSession,
            session,
        } = this.props;
        if (!productState.value) return;

        const isProRewardsUser = userRoles && userRoles.includes("ADIProRewards");
        const invitedStatus = ["A", "B", "O"];
        const isAuthenticated = session.isAuthenticated;
        const accNoSession = acNoSession?.toString().split("-")[0];
        const accNoLTY = loyaltyUserStateStore.user.userId !== undefined ? loyaltyUserStateStore.user.userId : "";
        const emailLTY =
            loyaltyUserStateStore.user.email !== undefined ? loyaltyUserStateStore.user.email?.toLocaleLowerCase() : "";
        const isRewardInvitedUser =
            invitedStatus.indexOf(loyaltyUserStateStore.user.status) > -1 &&
            !isProRewardsUser &&
            accNoLTY === accNoSession &&
            loyaltyUserStateStore.user.isEnrolled === false &&
            userNameSession === emailLTY;
        const isRewardEnrolledUser =
            invitedStatus.indexOf(loyaltyUserStateStore.user.status) > -1 &&
            accNoLTY === accNoSession &&
            loyaltyUserStateStore.user.isEnrolled &&
            (isProRewardsUser || false);

        const categoryUrl = productState.value.properties["productcategoryurl"] || "";
        const path = categoryUrl.split("/");
        const len = path.length;

        const pageUrl = `${categoryUrl}/${productState.value.productNumber}`;
        const l2Cat = len >= 5 ? path[len - (len === 6 ? 2 : 1)] : "";
        const l3Cat = len === 6 ? path[len - 1] : "";

        const bannerParams = {
            isPreview: false,
            pageUrl,
            adiNumber: productState.value.productNumber,
            brand: productState.value.brand?.urlSegment || "",
            personaType: "All",
            isPageTypePdp: true,
            l2Category: l2Cat,
            l3Category: l3Cat,
            ...(isAuthenticated && { isRewardInvitedUser, isRewardEnrolledUser }),
        };
        bannerCarousel(bannerParams);
        this.setState(prevState => ({ ...prevState, isBannerLoaded: true }));
    }
    UNSAFE_componentWillMount() {
        const { currentShipToState, loadCurrentShipTo, session, isProductLoading } = this.props;
        this.displayProductIfNeeded();
        this.setMetadata();
        if (
            session.isAuthenticated &&
            !isProductLoading &&
            !currentShipToState.value &&
            !currentShipToState.isLoading
        ) {
            loadCurrentShipTo();
        }
    }

    componentDidMount() {
        const parsedQuery = parseQueryString<{ psrid: string }>(this.props.location.search);
        if (parsedQuery && parsedQuery.psrid && window) {
            window.sessionStorage.setItem("adi_pricespider_webtoken", parsedQuery.psrid);
        }

        if (!this.state.isBannerLoaded && !this.props.isAuthenticated) {
            this.loadBanner();
        }
    }

    componentDidUpdate(prevProps: Props): void {
        this.displayProductIfNeeded();

        const {
            productState,
            acNoSession,
            session,
            selectedProductId,
            location: { search },
            productInfo,
            isAuthenticated,
            loyaltyUserStateStore,
            catalogSettings,
            productView,
        } = this.props;

        const { methods: productViewMethods } = productView;

        const specialOrderFlag =
            (catalogSettings.enableEdd &&
                productState &&
                productState.value?.properties["inventoryMessage"] &&
                productState.value?.properties["inventoryMessage"] === "Special Order") ||
            ((productState.value?.properties.classificatioN_CODE === "S" ||
                productState.value?.properties.classificatioN_CODE === "P" ||
                productState.value?.properties.classificatioN_CODE === "L") &&
                productState.value?.properties["inventoryMessageType"] === "3");

        // Handle Coveo product view event Logic
        const productId = productState.value?.id;
        const prevProductId = prevProps.productState.value?.id;
        const prevProductIdMatches = productId === prevProductId;
        if (productId && !prevProductIdMatches) {
            const name = productState.value?.productTitle;
            const price = productState.value?.pricing?.actualPrice || 0;
            // Emit product view event to coveo
            productViewMethods?.view({
                productId,
                name,
                price,
            });

            this.setState(prevState => ({ ...prevState, isBannerLoaded: false }));
        }

        if (!this.state.isBannerLoaded && (!isAuthenticated || !loyaltyUserStateStore.isLoading)) {
            this.loadBanner();
        }
        const isPRDomain = getIsPRDomain();
        const dataLayerCatList = productState.value?.properties?.datalayercategoryList;
        const queryParams = parseQueryString<{ option?: string; criteria?: string }>(search.replace("?", ""));
        const styledOption = (
            queryParams.option?.toString() ||
            queryParams.criteria?.toString() ||
            ""
        ).toLocaleLowerCase();
        const pricing = productInfo?.pricing;

        if (productState.value && productState.value.id !== this.state.metadataSetForId) {
            trackPageChange();
            this.setMetadata();
        }

        if (
            selectedProductId &&
            (dataLayerCatList || styledOption !== "") &&
            (pricing || !isAuthenticated) &&
            !this.state.isdataLayerLogged
        ) {
            const itemListName = sessionStorage.getItem("item_list_name");
            if (itemListName) {
                pushProductDetailDataToDataLayer(
                    productState.value,
                    "select_item",
                    itemListName ?? "",
                    session,
                    pricing,
                );
                pushProductDetailDataToDataLayer(productState.value, "view_item", "", session, pricing);
                sessionStorage.setItem("item_list_name", "");
            } else {
                pushProductDetailDataToDataLayer(productState.value, "view_item", "", session, pricing);
            }
            this.setState({
                isdataLayerLogged: true,
            });
        }

        if (
            this.props.isAuthenticated &&
            this.props.currentShipToState?.value?.postalCode &&
            this.props.productState.value?.productNumber &&
            !this.props.productState.value?.isVariantParent &&
            (this.props.productState.value?.productNumber !== prevProps.productState.value?.productNumber ||
                this.makePuddlesCall.current)
        ) {
            this.props.LoadInventoryPuddles({
                productId: this.props.productState.value?.productNumber,
                postalCode: this.props.currentShipToState?.value?.postalCode,
                IsLbIndicator:
                    this.props.productState.value?.properties?.logicBroker?.toLowerCase() === "yes" ||
                    this.props.productState.value?.properties?.lbi?.toLowerCase() === "yes"
                        ? "1"
                        : "0",
                IsLBInonSplOrd: IsLBInonSplOrdANDnotLB(this.props.productState.value),
            });
            if (!isPRDomain) {
                this.props.loadEddMethods({
                    customer: acNoSession ?? "",
                    zipcode: this.props.currentShipToState?.value?.postalCode
                        ? this.props.currentShipToState?.value?.postalCode.trim()
                        : "",
                    ordertype: "NS",
                    isSpecialOrder: specialOrderFlag,
                    items: this.props.productState.value ? this.props.productState.value?.productNumber : "",
                });
            }
            (this.makePuddlesCall as React.MutableRefObject<boolean>).current = false;
        }
    }

    componentWillUnmount() {
        this.props.resetSelections();
    }

    setMetadata() {
        const {
            productState: { value: product },
            catalogPageState,
            websiteName,
            location,
            websiteSettings,
        } = this.props;

        if (!catalogPageState?.value || !product) {
            return;
        }

        const {
            metaDescription,
            metaKeywords,
            openGraphImage,
            openGraphTitle,
            openGraphUrl,
            title,
            alternateLanguageUrls,
        } = catalogPageState.value;

        setPageMetadata(
            {
                metaDescription,
                metaKeywords,
                openGraphImage,
                openGraphTitle,
                openGraphUrl,
                currentPath: location.pathname,
                canonicalPath: product.canonicalUrl,
                title: title || product.productTitle,
                websiteName,
                alternateLanguageUrls: alternateLanguageUrls ?? undefined,
            },
            websiteSettings,
        );

        this.setState({
            metadataSetForId: product.id,
        });
    }

    displayProductIfNeeded() {
        const {
            location: { search },
            productPath,
            lastProductPath,
            lastStyledOption,
            isProductLoading,
        } = this.props;
        const queryParams = parseQueryString<{ option?: string; criteria?: string }>(search.replace("?", ""));
        const styledOption = (
            queryParams.option?.toString() ||
            queryParams.criteria?.toString() ||
            ""
        ).toLocaleLowerCase();
        if (
            productPath.toLowerCase() === lastProductPath?.toLowerCase() &&
            styledOption === lastStyledOption?.toLowerCase()
        ) {
            return;
        }

        if (isProductLoading) {
            return;
        }

        this.setState({
            isdataLayerLogged: false,
        });

        this.props.displayProduct({ path: productPath, styledOption });
    }

    render() {
        const styles = productDetailsPageStyles;

        if (!this.props.productState.value || !this.props.productInfo || this.props.isProductLoading) {
            return <LoadingOverlay loading={true} {...styles.loadingOverlay} />;
        }

        const productId = this.props.productState.value.id;

        const productContext: ProductContextModel = {
            product: this.props.productState.value,
            productInfo: this.props.productInfo,
            onQtyOrderedChanged: o => {
                this.props.changeQtyOrdered({
                    qtyOrdered: o,
                    productId,
                });
            },
            onUnitOfMeasureChanged: o => {
                this.props.changeUnitOfMeasure({
                    unitOfMeasure: o,
                    productId,
                });
            },
        };

        return (
            <Page data-test-selector={`productDetails_productId_${productId}`}>
                {this.props.selectedProductId && (
                    <CurrentCategory>
                        <ProductContext.Provider value={productContext}>
                            <ParentProductIdContext.Provider value={this.props.parentProductState?.value?.id}>
                                <Zone contentId={this.props.id} zoneName="Content" />
                                <ProductCompareFlyOut />
                                <Hidden above="md">
                                    <ScrollToTop />
                                </Hidden>
                            </ParentProductIdContext.Provider>
                        </ProductContext.Provider>
                    </CurrentCategory>
                )}
                <Modals />
            </Page>
        );
    }
}

const pageModule: PageModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withCoveoHooks(ProductDetailsPage)),
    definition: {
        hasEditableUrlSegment: false,
        hasEditableTitle: false,
        supportsProductSelection: true,
        pageType: "System",
    },
};

export default pageModule;

export const ProductDetailsPageContext = "ProductDetailsPage";
